var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('kendo-notification',{ref:"notification",attrs:{"id":"notificationToasterId","templates":_vm.templateToasterFn,"autoHideAfter":_vm.HideNotificationToaster}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }